import React, { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { getDetailOfCaseInCRM } from 'features/common/helpers';
import { getSaleOrderByDealId } from 'features/transaction-details/services';

interface RefundImpactNavigationButtonsProps {
	dealId: number;
	saleOrderId?: string | null;
	onError?: (message: string) => void;
}

export const RefundImpactNavigationButtons = ({
	dealId,
	saleOrderId,
	onError,
}: RefundImpactNavigationButtonsProps): JSX.Element => {
	const [loadingSaleOrder, setLoadingSaleOrder] = useState(false);
	const caseUrl = getDetailOfCaseInCRM(dealId);

	const handleGoToSaleOrder = async (): Promise<void> => {
		if (saleOrderId) {
			window.open(`/salesorder/${saleOrderId}`, '_blank', 'noopener,noreferrer');
			return;
		}

		setLoadingSaleOrder(true);
		try {
			const response = await getSaleOrderByDealId(dealId);
			const id = response.data.elements?.[0]?.id;
			if (id) {
				window.open(`/salesorder/${id}`, '_blank', 'noopener,noreferrer');
			} else {
				onError?.('No se encontró sale order para este caso de venta.');
			}
		} catch {
			onError?.('Error al buscar la sale order.');
		} finally {
			setLoadingSaleOrder(false);
		}
	};

	return (
		<Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1.5 }}>
			<Button
				size="small"
				variant="outlined"
				color="primary"
				startIcon={<OpenInNewIcon />}
				href={caseUrl}
				target="_blank"
				rel="noopener noreferrer"
			>
				Ir a caso de venta
			</Button>
			<Button
				size="small"
				variant="contained"
				color="primary"
				startIcon={loadingSaleOrder ? <CircularProgress size={16} color="inherit" /> : <ShoppingCartIcon />}
				onClick={() => void handleGoToSaleOrder()}
				disabled={loadingSaleOrder}
			>
				Ir a sale order
			</Button>
		</Box>
	);
};
